import CapacityManagementLayout from "./CapacityManagementLayout";

export default function CapacityManagementRoute() {
  return <CapacityManagementLayout />;
}
